import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { channelsBaseUrlService } from '@/services';

/**
 * Hook for managing channels base URL operations
 */

// Query key factory
const channelsBaseUrlKeys = {
  all: ['channelsBaseUrl'] as const,
  config: () => [...channelsBaseUrlKeys.all, 'config'] as const,
};

/**
 * Hook to get channels base URL configuration
 */
export const useChannelsBaseUrl = () => {
  return useQuery({
    queryKey: channelsBaseUrlKeys.config(),
    queryFn: channelsBaseUrlService.getChannelsBaseUrl,
    select: (data) => data.channelsBaseUrl,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

/**
 * Hook to update channels base URL
 */
export const useUpdateChannelsBaseUrl = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (baseUrl: string) => channelsBaseUrlService.updateChannelsBaseUrl(baseUrl),
    onSuccess: (data) => {
      // Update the cache with the new data
      queryClient.setQueryData(channelsBaseUrlKeys.config(), data);
      // Optionally invalidate to ensure fresh data
      queryClient.invalidateQueries({ queryKey: channelsBaseUrlKeys.all });
    },
  });
};
